import { IdCardTypeEnum } from '@/enums/IdCardTypeEnum'

export const IdCardTypesByCountry: Dictionary<Array<IdCardTypeEnum>> = {
  PE: [IdCardTypeEnum.NATIONAL_ID_CARD, IdCardTypeEnum.PASSPORT, IdCardTypeEnum.BUSINESS_REGISTRATION_NUMBER]
}
